<template>
  <div>
    Videos - {{$route.params.id}}
  </div>
</template>

<script>
export default {
  name: 'Videos'
};
</script>

<style>
</style>